import React, { Fragment } from "react";
import { Box, Card, Typography, Skeleton } from "@mui/material";
import { useQuery } from "react-query";
import { getAllUsersData } from "../../services/Users";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";

const t = {
  cardBg: "#ffffff",
  border: "#e0daf0",
  accent: "#6c5ce7",
  accentLight: "#f0edfd",
  accentMid: "#ece8fb",
  textPrimary: "#1a1a2e",
  textSecondary: "#6b6b80",
  textMuted: "#a0a0b0",
  radius: "12px",
};

const UserStats = () => {
  const { data: users = [], isLoading } = useQuery(
    "getAllUsersData",
    getAllUsersData,
    {
      refetchOnWindowFocus: false,
      useErrorBoundary: false,
      suspense: true,
    }
  );

  return (
    <Fragment>
      <Card
        variant="outlined"
        sx={{
          background: t.cardBg,
          border: `0.5px solid ${t.border}`,
          borderRadius: t.radius,
          boxShadow: "none",
          p: 2.5,
          display: "flex",
          alignItems: "center",
          gap: 2,
          height: "100%",
        }}
      >
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: "14px",
            background: t.accentMid,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <PeopleAltOutlinedIcon sx={{ color: t.accent, fontSize: 26 }} />
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              color: t.textSecondary,
              letterSpacing: "0.03em",
              mb: 0.5,
            }}
          >
            Total Users
          </Typography>
          {isLoading ? (
            <Skeleton width={48} height={36} />
          ) : (
            <Typography
              sx={{
                fontSize: "32px",
                fontWeight: 700,
                color: t.textPrimary,
                lineHeight: 1,
              }}
            >
              {users?.length ?? 0}
            </Typography>
          )}
        </Box>
      </Card>
    </Fragment>
  );
};

UserStats.defaultProps = {};
UserStats.propTypes = {};

export default UserStats;